import React from 'react';
import { Checkbox, Flex, Input, Label, ThemeUIStyleObject } from 'theme-ui';

import { IsRegex, OnChangeComponentParams, Search } from '../types';

type Props = {
  search: Search;
  isRegex: IsRegex;
  onChange: (changed: OnSearchChangeParams) => void;
};
export type OnSearchChangeParams = OnChangeComponentParams<Props>;

const styles: Record<string, ThemeUIStyleObject> = {
  label: {
    alignItems: 'center',
    marginRight: 2,
    width: 'auto',
  },
  input: {
    marginLeft: 2,
    maxWidth: '200px',
  },
};

export const SearchComponent: React.FC<Props> = ({
  search,
  isRegex,
  onChange,
}) => {
  return (
    <Flex mt={3} px={3}>
      <Label htmlFor="search" sx={styles.label}>
        search
        <Input
          id="search"
          value={search}
          sx={styles.input}
          onChange={event => onChange({ search: event.target.value, isRegex })}
        />
      </Label>
      <Label htmlFor="is-regex" sx={styles.label}>
        <Checkbox
          id="is-regex"
          checked={isRegex}
          onChange={event =>
            onChange({ search, isRegex: event.target.checked })
          }
        />
        regex
      </Label>
    </Flex>
  );
};
